import { ActionContext, ActionTree, Store } from "vuex";
import { WriterTypeIndicatorClient } from "@/lib/clients";
import { CopyFromGuestResultInput, CopyFromGuestResultOutput } from "@/lib/models/writerTypeIndicator";
import { AuthService } from "@/lib/auth";
import { getLocalStorage, removeLocalStorage } from "@/lib/localStorage";

const authService = new AuthService();
const writerTypeIndicatorClient = new WriterTypeIndicatorClient();

export type writerTypeIndicatorRequestType = "signup" | "signin";

type copyFromGuestResultPayload = {
  accessToken: string;
  guestUserId: string;
};

type Actions = {
  checkGuestResult: (
    this: Store<{}>,
    injectee: ActionContext<{}, {}>,
    payload: writerTypeIndicatorRequestType
  ) => Promise<void>;
  copyFromGuestResult: (
    this: Store<{}>,
    injectee: ActionContext<{}, {}>,
    payload: copyFromGuestResultPayload
  ) => Promise<CopyFromGuestResultOutput>;
};

const actions: ActionTree<{}, {}> & Actions = {
  async checkGuestResult({ dispatch }, requestType) {
    const GUEST_USER_ID_KEY = "writer-type-indicator:guestUserId";

    // ローカルストレージに作家タイプ診断のゲストユーザーIDがあるか確認
    const guestUserId = getLocalStorage(GUEST_USER_ID_KEY);
    if (!guestUserId) return;

    // アクセストークンを取得
    const accessToken = await authService.getAccessToken();
    if (!accessToken) return;

    // 作家タイプ診断のAPIを呼び出す
    const payload = {
      accessToken,
      guestUserId,
    };
    const result = await dispatch("copyFromGuestResult", payload);
    const { userId, penname } = result;

    if (userId) {
      removeLocalStorage(GUEST_USER_ID_KEY);
    }

    // 新規登録時に、診断結果にペンネームが設定されている場合は、ユーザーのペンネームに設定する
    if (requestType === "signup" && penname) {
      dispatch("userModule/updateUser", penname, { root: true });
    }
  },
  async copyFromGuestResult(_, payload) {
    const { accessToken, guestUserId } = payload;
    const headers = {
      "Access-Token": accessToken,
    };
    const body: CopyFromGuestResultInput = {
      guestUserId,
    };
    return await writerTypeIndicatorClient.copyFromGuestResult(headers, body);
  },
};

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions,
  mutations: {},
};
